import React, { ReactNode, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Header from './layout/Header';
import Footer from './layout/Footer';

interface LayoutProps {
  children: ReactNode;
}

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
  width: 100%;
  min-width: 0;
  scroll-margin-top: 6rem;
`;

const SkipLink = styled.a`
  position: fixed;
  top: 0.75rem;
  left: 0.75rem;
  transform: translateY(-200%);
  z-index: 1000;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background: var(--color-cream);
  color: var(--color-midnight);
  font-weight: 700;
  &:focus { transform: translateY(0); }
`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname, hash } = useLocation();
  const previousPath = useRef(pathname);
  useEffect(() => {
    if (previousPath.current === pathname) return;
    previousPath.current = pathname;
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.getElementById('main-content')?.focus({ preventScroll: true });
  }, [pathname, hash]);

  return (
    <LayoutWrapper>
      <SkipLink href="#main-content">Skip to content</SkipLink>
      <Header />
      <MainContent id="main-content" tabIndex={-1}>
        {children}
      </MainContent>
      <Footer />
    </LayoutWrapper>
  );
};

export default Layout;
